<template>
<div class="infoFooter">
  <div class="infoFooter__center">
    <div
      class="infoFooter__item infoFooter__item--clickable"
      @click="sendEmail()"
      >
      info@rideq.se
    </div>
    <div
      class="infoFooter__item infoFooter__item--clickable"
      @click="goTo('InfoPage')"
      >
      {{__('User manual')}}
    </div>
    <div
      class="infoFooter__item infoFooter__item--clickable"
      @click="goTo('LegalPage')"
      >
      {{__('Terms of purchase & use')}}
    </div>
    <div
      class="infoFooter__item infoFooter__item--clickable"
      @click="goTo('HomePage')"
      >
      © RideQ AB 2019
    </div>
  </div>
</div>
</template>
<script>
export default {
  data () {
    return {}
  },
  methods: {
    sendEmail () {
      window.location.href = 'mailto:info@rideq.se?subject=Hej!'
    },
    goTo (name) {
      const params = {
        lang: 'swe',
        product: 'headq'
      }
      this.$router.push({ name, params })
    }
  }
}
</script>
<style lang="less" scoped>
  @import '~style/elElement/variables.less';

  .infoFooter {
    width: 100%;
    box-sizing: border-box;
    padding: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;

    &__center {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;
      max-width: @section-max-width;
    }

    &__item {
      font-size: 14px;
      margin-top: 5px;

      @media (max-width: @section-max-width) {
        font-size: 12px;
      }

      &--clickable {
        cursor: pointer;

        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
</style>
